<template>
<div>
  <v-form class="container p-5 " ref="form" v-model="valid" lazy-validation>
<h5 > <b>Channel</b> </h5> 
    <v-row>
      <v-col>
        <v-text-field v-model="form.channelName" :rules="channelNameRules" label="Channel Name" required></v-text-field>
        <v-text-field v-model="form.imageLink" :rules="imageLinkRules" label="Image Link" required></v-text-field>
      </v-col>
      <v-col>
        <v-select
          :items="channelType"
          required
          :rules="[v => !!v || 'select channel type']"
          label="Channel Type"
          v-model="form.channelType"
        ></v-select>
         <v-text-field v-model="form.broadcaster" :rules="broadcasterRules" label="Broadcaster" required></v-text-field>
              </v-col>
    </v-row>

    <v-btn :disabled="!valid" class="primary mr-4" @click="handleSubmit">Submit</v-btn>
  </v-form>
</div>
</template>
<script>
import { extractError } from "../../utils/error";
import { channelmaster } from "@/services/channelmaster";

export default {
  data: () => ({
    form: {
      channelName: "",
      channelType: "",
      imageLink: "",
      broadcaster: "",
      hardware: "ALL",
      valid: true,
      channelFilter: true,
      status: 1
    },

    channelType: ["SD", "HD"],

    channelNameRules: [v => !!v || "Name is Required"],
    imageLinkRules: [v => !!v || "Image URL is required"],
    broadcasterRules: [v => !!v || "Broadcaster is required"],
    valid: true,
    select: null
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      try {
        const hasError = this.validate();
        if (hasError) {
          this.$toasted.error(hasError, {
            duration: 2000
          });
          return;
        }
        const { form, ...payload } = this.form;

        const result = await channelmaster(payload);
        //const { response: { userID: userId }  } = result;
        payload[form] = true;
        this.$router.push({
          name: "Channelmaster",
          params: {}
        });
        this.$toasted.success("Successfully created", {
          duration: 2000
        });
      } catch (err) {
        const message = extractError(err);
        this.$showError(message);
      }
    }
  }
};
</script>
<style scoped>
/* .forum{
    margin-left:3 rem !important;
} */
</style>